import loadjsLib from 'loadjs'

export const truthyAttributes = [true, 1, 'true', '1', 'enabled']

export function isTruthyAttribute(val: string | boolean | null): boolean {
  return truthyAttributes.indexOf(val) !== -1
}

export async function loadjs(paths: string[], key: string): Promise<void> {
  return new Promise((resolve, reject) => {
    if (loadjsLib.isDefined(key)) {
      loadjsLib.ready(key, () => {
        return resolve()
      })
    } else {
      loadjsLib(paths, key, {
        error: reject,
        success: resolve
      })
    }
  })
}

// https://stackoverflow.com/a/24829409
export function getPosition(element: HTMLElement): { x: number; y: number } {
  let xPosition = 0
  let yPosition = 0

  while (element) {
    xPosition += element.offsetLeft - element.scrollLeft + element.clientLeft
    yPosition += element.offsetTop - element.scrollTop + element.clientTop
    element = element.offsetParent as HTMLElement
  }

  return { x: xPosition, y: yPosition }
}
